import { Box, styled } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: row;
  padding: 0 !important;
  height: 100%;
`;

export const Content = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 24px;
  overflow: hidden;
`;
